import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { akEditorGridLineZIndex } from '@atlaskit/editor-shared-styles';
import { GuidelineContainer } from './ui/guidelineContainer';
var guidelineStyles = css({
  position: 'absolute',
  width: '100%',
  left: 0,
  right: 0,
  transform: "scale(1)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  zIndex: "".concat(akEditorGridLineZIndex, ";"),
  display: 'flex',
  justifyContent: 'center'
});
var key = new PluginKey('guidelinePlugin');
var displayGuideline = function displayGuideline(view) {
  return function (props) {
    var dispatch = view.dispatch,
      state = view.state;
    var tr = state.tr.setMeta(key, props);
    dispatch(tr);
    return true;
  };
};
export var EMPTY_STATE = {
  guidelines: []
};
var guidelinePMPlugin = new SafePlugin({
  key: key,
  state: {
    init: function init() {
      return EMPTY_STATE;
    },
    apply: function apply(tr, currentPluginState) {
      var nextPluginState = tr.getMeta(key);
      if (nextPluginState) {
        return _objectSpread(_objectSpread({}, currentPluginState), nextPluginState);
      }
      return currentPluginState;
    }
  }
});
var selector = function selector(states) {
  var _states$widthState, _states$widthState2, _states$guidelineStat, _states$guidelineStat2;
  return {
    width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width,
    lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength,
    guidelines: (_states$guidelineStat = states.guidelineState) === null || _states$guidelineStat === void 0 ? void 0 : _states$guidelineStat.guidelines,
    rect: (_states$guidelineStat2 = states.guidelineState) === null || _states$guidelineStat2 === void 0 ? void 0 : _states$guidelineStat2.rect
  };
};
var ContentComponent = function ContentComponent(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView,
    options = _ref.options;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['width', 'guideline'], selector),
    width = _useSharedPluginState.width,
    lineLength = _useSharedPluginState.lineLength,
    guidelines = _useSharedPluginState.guidelines,
    rect = _useSharedPluginState.rect;
  if (!width || !lineLength || !guidelines || guidelines.length === 0) {
    return null;
  }
  var updateRect = function updateRect(_ref2) {
    var top = _ref2.top,
      left = _ref2.left;
    var dispatch = editorView.dispatch,
      state = editorView.state;
    var _ref3 = rect || {},
      prevTop = _ref3.top,
      prevLeft = _ref3.left;
    if (prevTop !== top || prevLeft !== left) {
      var tr = state.tr.setMeta(key, {
        rect: {
          top: top,
          left: left
        }
      });
      dispatch(tr);
      return true;
    }
  };
  return jsx("div", {
    css: guidelineStyles
  }, jsx(GuidelineContainer, {
    guidelines: guidelines
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    ,
    height: editorView.dom.scrollHeight,
    width: width,
    editorWidth: lineLength,
    updateRect: updateRect
  }));
};

/**
 * Guideline plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */
export var guidelinePlugin = function guidelinePlugin(_ref4) {
  var options = _ref4.config,
    api = _ref4.api;
  return {
    name: 'guideline',
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return null;
      }
      return key.getState(editorState) || null;
    },
    actions: {
      displayGuideline: displayGuideline
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'guideline',
        plugin: function plugin() {
          return guidelinePMPlugin;
        }
      }];
    },
    contentComponent: function contentComponent(_ref5) {
      var editorView = _ref5.editorView;
      if (!editorView) {
        return null;
      }
      return jsx(ContentComponent, {
        editorView: editorView,
        options: options,
        api: api
      });
    }
  };
};